<template>
  <div>
    <condition-part
      :hasDate="false"
      :hasExcel="true"
      :hasPdf="true"
      :hasAdd="false"
      :hasEdit="false"
      :hasRemove="false"
      :hasFoodSupplier="true"
      :hasFoodStatusType="true"
      :hasWarehouse="true"
      :hasFoodKind="true"
      :hasFood="true"
      :hasBatchNumber="true"
      :hasQtyType="true"
      :columns="columns"
      :items="items"
      :pagination="pagination"
      :isSortable="true"
      @getItems="getItems"
      @downloadExcel="downloadExcel"
      @printPdf="printPdf"
      @downloadPdf="downloadPdf"
    />
  </div>
</template>

<script>
import conditionPart from "@/components/parts/conditionPart";

export default {
  data() {
    return {
      items: [],
      pagination: {},
    };
  },
  computed: {
    columns() {
      let s = [
        { name: "WarehouseNumber" },
        { name: "WarehouseName" },
        { name: "FoodNumber" },
        { name: "FoodName" },
        { name: "Barcode" },
        { name: "BatchNumber" },
        { name: "Qty" },
        { name: "Unit" },
        { name: "FoodKindNumber" },
        { name: "FoodKindName" },
      ];
      return s;
    },
  },
  components: {
    conditionPart,
  },
  methods: {
    setWarehouses(items) {
      this.warehouseIds = items;
    },
    setFoodKinds(items) {
      this.foodKindIds = items;
    },
    downloadExcel(condition) {
      this.$api.reportExcels.getStockBatch(condition);
    },
    downloadPdf(condition) {
      this.$api.reportPdfs.getStockBatch(condition);
    },
    printPdf(condition) {
      this.$api.reportPdfs.printStockBatch(condition);
    },
    getItems(condition) {
      const vm = this;
      this.$api.reports.getStockBatch(condition).then((data) => {
        vm.items = data.Datas;
        vm.pagination = data.Pagination;
      });
    },
  },
};
</script>
